import { ToolResult } from '../../types/tool.types';
import { ToolContext } from '../tool-context.type';

export async function lookAtObject (args: any, context: ToolContext): Promise<ToolResult> {
	const { threeInstance, publish } = context;
	if (!threeInstance) {
		return { success: false, error: 'Three.js instance not initialized' };
	}

	const { objectId, duration } = args;
	if (typeof objectId !== 'string') {
		return { success: false, error: 'objectId parameter must be a string' };
	}

	const durationMs = typeof duration === 'number' ? duration : 1000;

	const result = await threeInstance.lookAtObject(objectId, durationMs);
	if (!result) {
		return { success: false, error: `Object "${objectId}" not found in the 3D scene` };
	}

	publish('camera', 'change', {
		ref: 'look_at',
		old: null,
		new: { objectId, duration: durationMs }
	});

	return { success: true, data: { objectId, duration: durationMs } };
}
